import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import classnames from 'classnames';

import {colors} from '../colors/colors';
import {Link} from '../link/link';
import {RANKED_COLORS} from '../maps/consts';
import {ProgressBar} from '../progress-bar/progress-bar';

import type {Stat} from './types';

import styles from './ranked-stat-bar.module.css';

type Props = {
    rank: number;
    stat: Stat | null | undefined;
};

export function RankedStatBar(props: Props) {
    const {rank, stat} = props;

    const [percentValue, setPercentValue] = React.useState<number | null | undefined>(undefined);

    const rankIndex = rank - 1;
    let rankLabel = rank;

    if (rank < 10) {
        // @ts-expect-error
        rankLabel = `0${rank}`;
    }

    let Tag = 'div';
    let tagProps: Record<string, any> = {};

    if (stat && stat.linkTo) {
        // @ts-expect-error
        Tag = Link;
        tagProps = {
            to: stat.linkTo,
            newTab: true,
            as: RoutedLink,
            preventUnderline: true,
        };
    }

    // Effect + state needed to show animation when stat percentage changes
    React.useEffect(() => {
        setTimeout(() => {
            setPercentValue(stat ? stat.percentValue : undefined);
        }, 50);
    }, [stat]);

    return (
        <div className={styles['ranked-stat-bar-container']}>
            <div className={styles['rank-label']}>{rankLabel}:</div>
            {/* @ts-expect-error */}
            <Tag {...tagProps} className={classnames(styles['stat-container'], tagProps.className)}>
                <div className={styles['stat-label']}>
                    {stat ? (
                        <>
                            <strong>{stat.label}</strong>
                            {stat.sublabel ? <span>({stat.sublabel})</span> : undefined}
                        </>
                    ) : (
                        <div className={styles.placeholder} />
                    )}
                </div>
                <ProgressBar
                    percentComplete={percentValue}
                    backgroundColor={colors.offWhite}
                    roundedCorners={true}
                    showPercentage={true}
                    height={16}
                    color={
                        rankIndex < RANKED_COLORS.length
                            ? // @ts-expect-error
                              colors[RANKED_COLORS[rankIndex]]
                            : colors.grey // fallback color
                    }
                />
            </Tag>
        </div>
    );
}
